import axios, { AxiosInstance } from 'axios';
import { API_CONFIG } from '../config/api';

const portalApiClient: AxiosInstance = axios.create({
  baseURL: API_CONFIG.FULL_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: { 'Content-Type': 'application/json' },
});

// Attach client portal token from localStorage
portalApiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('client-portal-token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Generic helpers (same interface as apiClient.ts)
export const portalApi = {
  get: <T = unknown>(url: string) =>
    portalApiClient.get<T>(url).then(r => r.data),
  post: <T = unknown>(url: string, data?: unknown) =>
    portalApiClient.post<T>(url, data).then(r => r.data),
  put: <T = unknown>(url: string, data?: unknown) =>
    portalApiClient.put<T>(url, data).then(r => r.data),
  patch: <T = unknown>(url: string, data?: unknown) =>
    portalApiClient.patch<T>(url, data).then(r => r.data),
  delete: <T = unknown>(url: string) =>
    portalApiClient.delete<T>(url).then(r => r.data),
};

export default portalApiClient;
